import React, {useEffect} from 'react';
import {Route, Routes, useLocation, useParams} from 'react-router';

import {Page404} from "../../404";
import {ManyLocs} from "./many";
import {OneLoc} from "./one";

const OneLocRoute = () => { const {resid} = useParams(); return <OneLoc locid={resid} />; };

const ManyLocsRoute = () => {
    const location = useLocation();
    return <ManyLocs search={new URLSearchParams(location.search)} />;
};

const LocsPage = () => {
    useEffect(() => {
        console.log("Locs page");
    }, [])

    return <Routes>
        <Route path="/" element={<ManyLocsRoute />} />
        <Route path="/:resid" element={<OneLocRoute />} />
        <Route path="*" element={<Page404 />} />
    </Routes>
}

export { LocsPage };
